import { triggerPopup } from "../../../utils/modal/modal.js";

const bankDetails = () => {
  console.log("bank details called");

  triggerPopup();

  const ifscBtn = document.getElementById("ifsc-btn");
  const searchContainer = document.getElementById("search-container");
  const closeIfsc = document.getElementById("close-ifsc");
  // const radioBtns = [
  //   ...searchContainer?.querySelectorAll("input[type='radio']"),
  // ];
  let radioBtns = null;
  if(searchContainer) {
    radioBtns = [
      ...searchContainer?.querySelectorAll("input[type='radio']"),
    ];
  }
  console.log("radiobtns", radioBtns);
  const resetPopup = (form) => {
    const inputsAndButtons = form?.querySelectorAll("input, button");

    inputsAndButtons?.forEach((element) => {
      if (element.tagName === "INPUT") {
        if (element.type === "text") {
          element.value = ""; // Clear text and email inputs
        } else if (element.type === "radio") {
          element.checked = false; // Uncheck radio buttons and checkboxes
        }
      } else if (element.tagName === "BUTTON") {
        // Perform any specific reset logic for buttons if needed
        element.disabled = false;
        element.setAttribute("type", "button");
        element.textContent = "Search";
      }
    });

    searchContainer?.classList.remove("js-active");
  };

  ifscBtn?.addEventListener("click", function (e) {
    if (this.getAttribute("type") === "button") {
      searchContainer.classList.add("js-active");
      this.setAttribute("type", "submit");
      this.setAttribute("disabled", "true");
      this.textContent = "Continue";

      radioBtns.forEach((element) => {
        element.addEventListener("change", (e) => {
          console.log("change called");

          const isRadioChecked = radioBtns.some((element) => element.checked);
          if (isRadioChecked) {
            this.disabled = false;
          }
        });
      });
    }
  });
  closeIfsc?.addEventListener("click", function (e) {
    const formElement = this.closest(".modal").querySelector("form");
    resetPopup(formElement);
  });
};

export default bankDetails;
